import "./accessibility-menu.scss";
import React, { useState, useEffect } from "react";
import classNames from "classnames";

const AccessibilityMenu = ({ popup, setPopup }) => {
   /////
   // Accessibility options
   const [fontSize, setFontSize] = useState("regular");
   const [contrast, setContrast] = useState("low");
   const [underline, setUnderline] = useState("off");
   const [newRoot, setNewRoot] = useState(null);

   // Defining <html> as root
   const setRoot = () => {
      const root = document.getElementsByTagName("html")[0];
      setNewRoot(root);
   };

   // Font size
   const reduceFontSize = (e) => {
      if (fontSize === "bigger") {
         setFontSize("big");
         localStorage?.setItem("font-size", "big");
         setNewRoot(newRoot.setAttribute("font", "big"));
      } else if (fontSize === "big") {
         setFontSize("regular");
         localStorage?.setItem("font-size", "regular");
         setNewRoot(newRoot.setAttribute("font", "regular"));
      } else {
         clearTimeout();
         setPopup("");
         setPopup("smallFont");
         setTimeout(() => {
            setPopup("");
         }, 3500);
      }
   };

   const enlargeFontSize = () => {
      if (fontSize === "regular") {
         setFontSize("big");
         localStorage?.setItem("font-size", "big");
         setNewRoot(newRoot.setAttribute("font", "big"));
      } else if (fontSize === "big") {
         setFontSize("bigger");
         localStorage?.setItem("font-size", "bigger");
         setNewRoot(newRoot.setAttribute("font", "bigger"));
      } else {
         clearTimeout();
         setPopup("");
         setPopup("bigFont");
         setTimeout(() => {
            setPopup("");
         }, 3500);
      }
   };

   // Contrast
   const enableContrast = (e) => {
      if (contrast === "low") {
         setContrast("high");
         localStorage?.setItem("contrast", "high");
         setNewRoot(newRoot.setAttribute("contrast", "high"));
      } else {
         clearTimeout();
         setPopup("");
         setPopup("highContrast");
         setTimeout(() => {
            setPopup("");
         }, 3500);
      }
   };
   const disableContrast = (e) => {
      if (contrast === "high") {
         setContrast("low");
         localStorage?.setItem("contrast", "low");
         setNewRoot(newRoot.setAttribute("contrast", "low"));
      } else {
         clearTimeout();
         setPopup("");
         setPopup("lowContrast");
         setTimeout(() => {
            setPopup("");
         }, 3500);
      }
   };

   // Underline
   const handleUnderline = (e) => {
      if (underline === "on") {
         setUnderline("off");
         localStorage?.setItem("underline", "off");
         setNewRoot(newRoot.setAttribute("underline", "off"));
      } else {
         setUnderline("on");
         localStorage?.setItem("underline", "on");
         setNewRoot(newRoot.setAttribute("underline", "on"));
      }
   };

   // Reseting all settings
   const resetCurrentSettings = (e) => {
      // Popup
      setPopup("");
      clearTimeout();
      // Font size
      setFontSize("regular");
      localStorage?.setItem("font-size", "regular");
      setNewRoot(newRoot.setAttribute("font", "regular"));
      // Underline
      setUnderline("off");
      localStorage?.setItem("underline", "off");
      setNewRoot(newRoot.setAttribute("underline", "off"));
      document.getElementById("linkUnderline").checked = false;
      // Contrast
      setContrast("low");
      localStorage?.setItem("contrast", "low");
      setNewRoot(newRoot.setAttribute("contrast", "low"));
      // Keyboard navigation
      document.getElementById("keyboardNavigation").checked = false;
   };

   useEffect(() => {
      // Managing accessibility states
      setRoot();
      // Root attributes
      newRoot?.setAttribute(
         "font",
         localStorage?.getItem("font-size")
            ? localStorage?.getItem("font-size")
            : "regular"
      );
      newRoot?.setAttribute(
         "contrast",
         localStorage?.getItem("contrast")
            ? localStorage?.getItem("contrast")
            : "low"
      );
      newRoot?.setAttribute(
         "underline",
         localStorage?.getItem("underline")
            ? localStorage?.getItem("underline")
            : "off"
      );
      // State set
      setFontSize(
         localStorage?.getItem("font-size")
            ? localStorage?.getItem("font-size")
            : "regular"
      );
      setContrast(
         localStorage?.getItem("contrast")
            ? localStorage?.getItem("contrast")
            : "low"
      );
      setUnderline(
         localStorage?.getItem("underline")
            ? localStorage?.getItem("underline")
            : "off"
      );
   }, [newRoot]);

   return (
      <div className="accessibility-menu">
         <div className="accessibility-menu__font">
            <span className="accessibility-menu__label">
               Zmień rozmiar czcionki
            </span>
            <button
               type="button"
               className={classNames("button", {
                  ["button--disabled"]: fontSize === "regular",
               })}
               onClick={reduceFontSize}
            >
               -
            </button>
            <button
               type="button"
               className={classNames("button", {
                  ["button--disabled"]: fontSize === "bigger",
               })}
               onClick={enlargeFontSize}
            >
               +
            </button>
         </div>
         <div className="accessibility-menu__contrast">
            <span className="accessibility-menu__label">Wybierz kontrast</span>
            <button
               type="button"
               className={classNames("button", {
                  ["button--disabled"]: contrast === "low",
               })}
               onClick={disableContrast}
            >
               Aa
            </button>
            <button
               type="button"
               className={classNames("button button--high-contrast", {
                  ["button--high-contrast-disabled"]: contrast === "high",
               })}
               onClick={enableContrast}
            >
               Aa
            </button>
         </div>
         <div className="accessibility-menu__link">
            <fieldset className="accessibility-menu__fieldset">
               <input
                  type="checkbox"
                  name="link-underline"
                  className="accessibility-menu__checkbox"
                  id="linkUnderline"
                  checked={underline === "on" ? true : false}
                  onChange={handleUnderline}
               />
               <label htmlFor="linkUnderline">Podświetl linki</label>
            </fieldset>
         </div>

         <div className="accessibility-menu__keyboard">
            <fieldset className="accessibility-menu__fieldset">
               <input
                  className="accessibility-menu__checkbox"
                  type="checkbox"
                  name="keyboard-navigation"
                  id="keyboardNavigation"
               />
               <label htmlFor="keyboardNavigation">Nawigacja klawiaturą</label>
            </fieldset>
         </div>
         <button
            type="button"
            className="button"
            onClick={resetCurrentSettings}
         >
            Zresetuj
         </button>
      </div>
   );
};

export default AccessibilityMenu;
